import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZ6compD: IAbstractModule = {
    type: IModuleType.Z6comp,
    name: 'Z 6 compartment D',
    hasScreen: false,
    columns: [
        [
            {
                name: "1",
                connector: "1",
                cell_size_id: 1,
                accessible: false,
            },
            {
                name: "2",
                connector: "2",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "3",
                connector: "3",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "4",
                connector: "4",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "5",
                connector: "5",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "6",
                connector: "6",
                cell_size_id: 4,
                accessible: false,
            },
        ],
    ]
};
